import { render, staticRenderFns } from "./NewGenericInvoice.vue?vue&type=template&id=1356d1ad&scoped=true"
import script from "./NewGenericInvoice.vue?vue&type=script&lang=js"
export * from "./NewGenericInvoice.vue?vue&type=script&lang=js"
import style0 from "./NewGenericInvoice.vue?vue&type=style&index=0&id=1356d1ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1356d1ad",
  null
  
)

export default component.exports